// Pure decision for which login experience to render. Kept DOM/WebAuthn-free so
// it's unit-testable. See portal/src/views/login.ts (renderLogin) for wiring.
//
// We cannot truly ENUMERATE passkeys for this RP — WebAuthn hides that for
// privacy. The best available proxy for "this device belongs to an EXISTING
// user" is whether the device has remembered any account (signed in here before).
// When it hasn't, the user "might not have an account yet", so we flip to the
// signup-first experience.

export interface LoginExperienceInput {
  // Number of accounts remembered on THIS device (listAccounts().length).
  rememberedAccounts: number;
  // ?firstlogin=1 — force the new-user (signup-first) experience.
  forceNew: boolean;
  // ?existinguser=1 — force the current (sign-in-first) experience.
  forceExisting: boolean;
}

// Returns true when the SIGNUP-FIRST (new-user) experience should render.
// Precedence: forceExisting > forceNew > heuristic(no remembered accounts).
export function decideSignupFirst(input: LoginExperienceInput): boolean {
  if (input.forceExisting) return false;
  if (input.forceNew) return true;
  return input.rememberedAccounts <= 0;
}
